import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import ImagePlaceholder from 'images/icons/document_image_placeholder.png';
import commonStyles from 'views/SpecificationDocument/DocumentView/Common/commonStyles';
import defaultTextValue from 'views/SpecificationDocument/DocumentView/Common/defaultTextValue';
import Footer from 'views/SpecificationDocument/DocumentView/Common/Footer';
import PdfHeader from 'views/SpecificationDocument/DocumentView/Common/Header';
const styles = StyleSheet.create({
    page: {
        fontFamily: 'Inter',
        fontWeight: 'medium',
        paddingTop: '3%',
        paddingBottom: '4%',
    },
    detailsContainer: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        marginHorizontal: commonStyles.marginHorizontal,
        marginBottom: '4%',
    },
    image: {
        objectFit: 'contain',
        width: '45%',
        padding: '2.5% 3%',
        border: '1px solid #b8b8b8',
    },
    detailsColumn: {
        width: '55%',
        paddingLeft: '3%',
    },
    section: {
        marginHorizontal: commonStyles.marginHorizontal,
        marginBottom: '4%',
    },
    sectionTitle: Object.assign(Object.assign({}, commonStyles.fontS), { paddingBottom: 4, borderBottom: '1px solid #b8b8b8', marginBottom: 5 }),
    detailRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 5,
        marginBottom: 4,
    },
    detailLabel: Object.assign(Object.assign({}, commonStyles.fontXS), { width: '45%', color: '#6b6b6b' }),
    detailValue: Object.assign(Object.assign({}, commonStyles.fontXS), { width: '55%' }),
    detailsSection: {
        marginBottom: 6,
    },
    descriptionText: Object.assign(Object.assign({}, commonStyles.fontXS), { marginLeft: 5 }),
    parametersGrid: {
        display: 'flex',
        flexDirection: 'row',
    },
    parametersColumn: {
        width: '50%',
    },
    parameterRow: {
        marginLeft: 5,
        marginBottom: 4,
    },
    parameterLabel: Object.assign(Object.assign({}, commonStyles.fontXS), { color: '#6b6b6b' }),
    parameterValue: Object.assign({}, commonStyles.fontXS),
});
function formatValue(value) {
    if (value === 0) {
        return '0';
    }
    return defaultTextValue(value);
}
function ComponentPdfPage({ component, supplierDetails, t, i18n, }) {
    var _a, _b, _c, _d, _e, _f;
    const categoryLabel = ((_a = i18n === null || i18n === void 0 ? void 0 : i18n.language) === null || _a === void 0 ? void 0 : _a.startsWith('pl'))
        ? (_b = component === null || component === void 0 ? void 0 : component.category) === null || _b === void 0 ? void 0 : _b.typeLabelPL
        : (_c = component === null || component === void 0 ? void 0 : component.category) === null || _c === void 0 ? void 0 : _c.typeLabelEN;
    const mainPhoto = ((_e = (_d = component === null || component === void 0 ? void 0 : component.pictures) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.picture) || ImagePlaceholder;
    const supplier = Object.assign(Object.assign({}, ((component === null || component === void 0 ? void 0 : component.supplier) || {})), (supplierDetails || {}));
    const producerCode = (_f = component === null || component === void 0 ? void 0 : component.producerCode) === null || _f === void 0 ? void 0 : _f.name;
    const parameters = (component === null || component === void 0 ? void 0 : component.parameters) || [];
    const middleIndex = Math.ceil(parameters.length / 2);
    const parametersLeft = parameters.slice(0, middleIndex);
    const parametersRight = parameters.slice(middleIndex);
    const supplierFields = [
        { label: t('specification:supplier_name_capitalize'), value: supplier === null || supplier === void 0 ? void 0 : supplier.fullName },
        { label: t('specification:supplier_shortname'), value: supplier === null || supplier === void 0 ? void 0 : supplier.shortName },
        { label: t('specification:supplier_code'), value: supplier === null || supplier === void 0 ? void 0 : supplier.code },
        { label: t('specification:vat_number'), value: supplier === null || supplier === void 0 ? void 0 : supplier.vatNumber },
        { label: t('specification:country_of_origin'), value: supplier === null || supplier === void 0 ? void 0 : supplier.countryOfOrigin },
        { label: t('specification:address_postal_code'), value: supplier === null || supplier === void 0 ? void 0 : supplier.addressPostalCode },
        { label: t('specification:address_city'), value: supplier === null || supplier === void 0 ? void 0 : supplier.addressCity },
        { label: t('specification:address_street'), value: supplier === null || supplier === void 0 ? void 0 : supplier.addressStreet },
        { label: t('specification:address_number'), value: supplier === null || supplier === void 0 ? void 0 : supplier.addressNumber },
        { label: t('specification:email_address'), value: supplier === null || supplier === void 0 ? void 0 : supplier.emailAddress },
        { label: t('specification:contact_phone'), value: supplier === null || supplier === void 0 ? void 0 : supplier.contactPhone },
    ];
    return (React.createElement(Page, { size: "A4", style: styles.page },
        React.createElement(PdfHeader, { title: component === null || component === void 0 ? void 0 : component.name }),
        React.createElement(View, { style: styles.detailsContainer },
            React.createElement(Image, { style: styles.image, src: mainPhoto }),
            React.createElement(View, { style: styles.detailsColumn },
                React.createElement(View, { style: styles.detailsSection },
                    React.createElement(Text, { style: styles.sectionTitle }, t('specification:basic_informations')),
                    React.createElement(View, { style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, t('common:name')),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(component === null || component === void 0 ? void 0 : component.name))),
                    React.createElement(View, { style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, t('specification:category')),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(categoryLabel))),
                    React.createElement(View, { style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, t('specification:producent_code')),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(producerCode))),
                    React.createElement(View, { style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, t('common:status')),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(component === null || component === void 0 ? void 0 : component.status))),
                    React.createElement(View, { style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, t('specification:active_variants')),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(component === null || component === void 0 ? void 0 : component.activeProductVariantsCount))),
                    React.createElement(View, { style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, t('specification:product_variants')),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(component === null || component === void 0 ? void 0 : component.productVariantsCount)))),
                React.createElement(View, null,
                    React.createElement(Text, { style: styles.sectionTitle }, t('specification:supplier')),
                    supplierFields.map(({ label, value }) => (React.createElement(View, { key: label, style: styles.detailRow },
                        React.createElement(Text, { style: styles.detailLabel }, label),
                        React.createElement(Text, { style: styles.detailValue }, formatValue(value)))))))),
        React.createElement(View, { style: styles.section },
            React.createElement(Text, { style: styles.sectionTitle }, t('specification:product_description')),
            React.createElement(Text, { style: styles.descriptionText }, formatValue(component === null || component === void 0 ? void 0 : component.productDescription))),
        React.createElement(View, { style: styles.section },
            React.createElement(Text, { style: styles.sectionTitle }, t('specification:parameters')),
            React.createElement(View, { style: styles.parametersGrid },
                React.createElement(View, { style: styles.parametersColumn }, parametersLeft.map((param) => (React.createElement(View, { key: param.id, style: styles.parameterRow },
                    React.createElement(Text, { style: styles.parameterLabel }, param.title),
                    React.createElement(Text, { style: styles.parameterValue }, formatValue(param.name)))))),
                React.createElement(View, { style: styles.parametersColumn }, parametersRight.map((param) => (React.createElement(View, { key: param.id, style: styles.parameterRow },
                    React.createElement(Text, { style: styles.parameterLabel }, param.title),
                    React.createElement(Text, { style: styles.parameterValue }, formatValue(param.name)))))))),
        React.createElement(Footer, { date: new Date(), code: producerCode, author: defaultTextValue('-'), folder: categoryLabel, model: component === null || component === void 0 ? void 0 : component.name })));
}
export default ComponentPdfPage;
